export const returnSellingPrice = (sellDetails) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (
        Object.keys(sellDetails).length > 0 &&
        sellDetails?.status === "FOR_SALE"
      ) {
        const price = sellDetails.price;
        resolve(parseInt(price) / Math.pow(10, 18));
      } else {
        resolve(-1);
      }
    } catch (e) {
      console.log(e);
      reject(-1);
    }
  });
};
